module.exports = __webpack_public_path__ + "img/xx1.40a62064.png";